// extracted by mini-css-extract-plugin
export var badge = "_v1-4";
export var selected = "_v1-1";
export var selectedOverlay = "_v1-5";
export var thumbnailButton = "_v1-0";
export var thumbnailFallback = "_v1-3";
export var thumbnailImage = "_v1-2";